import { get } from '../services/request';

export type IWordClassSelect = {
  id: number | null;
  name: string;
  hasGender: boolean;
  courseId?: number | null;
  inflectAs?: number | null;
};

export default class WordClassSelectModel {
  courseId: number;

  constructor(courseId: number) {
    this.courseId = courseId;
  }

  async get() {
    return await get<IWordClassSelect[]>(`/courses/${this.courseId}/word-classes`);
  }
}
